import { ThemeUICSSObject } from '@apia/theme';
import charts from './charts';
import renderChart from './renderChart';
import renderPivot from './renderPivot';
import offline from './offline';
import filtersSetters from './filtersSetters';
const query: ThemeUICSSObject = {
  charts: charts as unknown as ThemeUICSSObject,
  renderChart,
  renderPivot,
  offline,
  filtersSetters,

  extended: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
  },

  '.Extralarge': {
    variant: 'buttons.outline-extended',
  },
};

export default query;
